import { Response, RequestOptionsArgs } from '@angular/http';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { HttpService } from './http.service';
import { map } from 'rxjs/operators';

export abstract class SmBaseService {
	protected API_PREFIX = AppSettings.API_ENDPOINT;

	constructor(
		protected http: HttpService,
		protected ctrl: string
	) { }

	protected getUrl(path?: string | number): string {
		let s: string[] = [this.ctrl];
		if (path != null) {
			s.push('' + path);
		}

		return this.API_PREFIX + s.join('/');
	}

	protected _get(action?: string | number, options?: RequestOptionsArgs): Observable<Response> {
		return this.http.get(this.getUrl(action), options);
	}

	protected _getAs<TResult>(action?: string | number, options?: RequestOptionsArgs): Observable<TResult> {
		return this.as<TResult>(this._get(action, options));
	}

	protected _post(action: string | number, body: any, options?: RequestOptionsArgs): Observable<Response> {
		return this.http.post(this.getUrl(action), body, options);
	}

	protected _postAs<TResult>(action: string | number, body: any, options?: RequestOptionsArgs): Observable<TResult> {
		return this.as<TResult>(this._post(action, body, options));
	}

	protected _put(action: string | number, body: any, options?: RequestOptionsArgs): Observable<Response> {
		return this.http.put(this.getUrl(action), body, options);
	}

	protected _putAs<TResult>(action: string | number, body: any, options?: RequestOptionsArgs): Observable<TResult> {
		return this.as<TResult>(this._put(action, body, options));
	}

	protected _delete(action?: string | number, options?: RequestOptionsArgs): Observable<Response> {
		return this.http.delete(this.getUrl(action), options);
	}

	protected _deleteAs<TResult>(action?: string | number, options?: RequestOptionsArgs): Observable<TResult> {
		return this.as<TResult>(this._delete(action, options));
	}

	protected as<TResult>(observable: Observable<Response>): Observable<TResult> {
		return observable.pipe(map(res => res.json() as TResult));
	}

	private _dateTimeReviver(key, value) {
		if (typeof value == 'string') {
			// examples of some valid days
			// 0001-01-01T00:00:00
			// 0001-01-01T00:00:00Z
			// 0001-01-01T00:00:00.000
			// 0001-01-01T00:00:00.00000Z

			let date = /^([0-9][0-9][0-9][0-9])-(0[1-9]|1[012])-([012]\d|3[01])T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)/.exec(value);

			if (date) {
				return new Date(Date.UTC(+date[1], +date[2] - 1, +date[3], +date[4], +date[5], +date[6]));
			}
		}

		return value;
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/services/sm-base.service.ts